import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TabGroup as HeadlessTabGroup } from "@headlessui/vue";
// eslint-disable-next-line
interface GroupProps extends ExtractProps<typeof HeadlessTabGroup> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'Group',
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessTabGroup), { as: "div" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})